export default __webpack_public_path__ + "static/media/emptyState.5f96a426.svg";